var dust = require('dustjs-linkedin');
(function(dust){dust.register("src-web-reader-templates-readerComponent",body_0);function body_0(chk,ctx){return chk.w("<div class=\"reader-component\"><div class=\"reader-wrapper\"><div class=\"nav-col nav-col-prev\" id=\"reader-previous\"><div class=\"previous-icon\"></div></div><div class=\"nav-col nav-col-next\" id=\"reader-next\"><div class=\"next-icon\"></div></div><div class=\"reader-container\"><div id=\"turn-reader\"></div></div></div></div>");}body_0.__dustBody=!0;return body_0}(dust));
module.exports = 'src-web-reader-templates-readerComponent';


//////////////////
// WEBPACK FOOTER
// ./src/web/reader/templates/readerComponent.dust
// module id = 532
// module chunks = 1